<h3 mat-dialog-title>Access Denied</h3>
<div mat-dialog-content>
    <p>{{ message }}</p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="close()">OK</button>
</div>
